import './styles.scss'
import React from 'react'
import ReactTooltip from 'react-tooltip'
import uniqid from 'uniqid'

import InputControls from 'components/common/InputControls'
import { getStaticImage } from 'utils/statics'

const TranslateCardItem = ({ icon, title, tooltip, value, onChange, onClickConfigButton, className }) => {
  const id = uniqid('va-translation-item')

  return (
    <div className={`translate-card__item ${className ? className : ''}`}>
      <div className='translate-card__item-content'>
        <figure className='translate-card__item-icon'>
          <img src={icon} alt={title} title={title} />
        </figure>
        <strong className='translate-card__item-title'>{title}</strong>
      </div>
      <div className='translate-card__item-content'>
        {onClickConfigButton && typeof onClickConfigButton === 'function' && (
          <button className='translate-card__item-config-btn' onClick={onClickConfigButton}>
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-settings-secondary.svg')} alt='Configuration' />
            </figure>
          </button>
        )}
        {tooltip && (
          <i
            className='fa fa-info-circle'
            data-for={`tooltip-${id}`}
            data-tip={tooltip}
          ></i>
        )}
        <InputControls
          color='primary'
          value={value}
          onChange={onChange}
        />
      </div>
      <ReactTooltip id={`tooltip-${id}`} place='right' multiline={true} />
    </div>
  )
}

export default TranslateCardItem
